var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.estimate
    ? _c("div", { staticClass: "fee-estimate" }, [
        _c(
          "div",
          { staticClass: "fee-card" },
          [
            _vm._l(_vm.estimate.items, function(item, idx) {
              return _c("div", { key: idx, staticClass: "fee-line" }, [
                _c("span", { staticClass: "fee-label" }, [
                  _vm._v(_vm._s(item.size))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "fee-amount" }, [
                  _vm._v("$" + _vm._s(_vm.fmt(item.fee)))
                ])
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "fee-divider" }),
            _vm._v(" "),
            _vm.estimate.subtotal != null
              ? _c("div", { staticClass: "fee-line" }, [
                  _c("span", { staticClass: "fee-label" }, [
                    _vm._v("Subtotal")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fee-amount" }, [
                    _vm._v("$" + _vm._s(_vm.fmt(_vm.estimate.subtotal)))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "fee-divider thick" }),
            _vm._v(" "),
            _c("div", { staticClass: "fee-line total" }, [
              _c("span", { staticClass: "fee-label" }, [_vm._v("Total")]),
              _vm._v(" "),
              _c("span", { staticClass: "fee-amount" }, [
                _vm._v("$" + _vm._s(_vm.fmt(_vm.estimate.total)))
              ])
            ])
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e9a55ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e9a55ce","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeeEstimate.vue
// module id = 414
// module chunks = 0